/* EBD custom behaviour - E-Bike Centre.
   1) Product picture arrows. Sean's order of 28 August 2026, board tasks 191 and 197_PROJECTS-01.
      The purchased theme's own arrow controller, the custom element carousel-navigation in
      assets/carousel-slider.js, gives up after two tries 350ms apart and leaves the two arrows over
      the big bike picture attached to nothing. This binds them straight to the gallery's own
      setActiveMedia method - the very same method the theme already uses when a shopper clicks one
      of the small pictures - so nothing about the gallery changes except that the arrows now work.
      It works whether or not the sliding library is running, which matters because the theme
      switches the sliding off on screens 750 pixels wide and over.

      ============== 269_PROJECTS-01 - 30 AUGUST 2026: THIS BLOCK NOW STANDS DOWN ==============

      WHAT SEAN REPORTED. On a product page, one press of an arrow over the big photograph moved the
      gallery on by TWO photographs instead of one. It happened on every press, not now and then.

      WHY IT HAPPENED. Two separate pieces of code were answering the same press. The purchased
      Athens & Spoke theme's own sliding library, Flickity, moved the gallery on one photograph, and
      then this block moved it on one more. Board task 237_PROJECTS-01, finished earlier on
      30 August 2026, repaired the three faulty July 2026 scripts inside the theme file
      sections/header-group.json that had been destroying every arrow press below 990 pixels of
      window width. That repair brought the theme's own arrow code back to life, and nobody switched
      the help in this block off, so from that moment both of them moved the gallery.

      MEASURED ON THE DALLINGRIDGE CONISTON V3 PRODUCT PAGE OF THE DRAFT THEME EBikeDepot v18d ON
      30 AUGUST 2026, BEFORE THIS CHANGE WAS MADE. The right-hand column says whether the theme's
      own sliding library was running, which the page writes down as the class flickity-enabled on
      the element div.product-media-main-wrapper:

           375 pixels wide - sliding library RUNNING     - one press moved photograph 1 to 3, 3 to 5
           600 pixels wide - sliding library RUNNING     - one press moved photograph 1 to 3, 3 to 5
           749 pixels wide - sliding library RUNNING     - one press moved photograph 1 to 3, 3 to 5
           900 pixels wide - sliding library NOT running - one press moved photograph 1 to 2, 2 to 3
          1400 pixels wide - sliding library NOT running - one press moved photograph 1 to 2, 2 to 3

      WHY THIS BLOCK IS NOT SIMPLY DELETED, WHICH IS THE IMPORTANT PART. At 900 and 1400 pixels the
      theme switches its sliding library OFF, and with it off the theme answers an arrow press with
      NOTHING AT ALL. Every one of those correct single moves at 900 and 1400 pixels came from this
      block and from nowhere else, proved by reading the trail of calls back to its source, which
      named ebd-custom.js and no theme file. Deleting this block would therefore leave the two
      arrows over the big photograph completely dead on every desktop screen, which is exactly where
      a shopper uses a mouse.

      WHAT THIS BLOCK NOW DOES INSTEAD. Before it moves anything it asks one question: is the
      theme's own sliding library running on this gallery right now? The answer is written on the
      page as the class flickity-enabled on div.product-media-main-wrapper, the box the two arrows
      sit inside. If that library IS running, the theme moves the picture itself, so this block
      stands aside and moves nothing. If it is NOT running, this block moves the picture exactly as
      it did before. One press, one photograph, at every width.

      WHEN IT STANDS ASIDE IT DOES NOTHING AT ALL, AND THAT PLAINNESS WAS FORCED BY A MEASUREMENT.
      The first attempt at this repair, made and tested on 30 August 2026, kept a net: it stood
      aside, waited 350 milliseconds, looked again, and moved the picture only if nothing had
      happened. That is the same wait-and-check pattern block 4 below uses for the film strip under
      board task 242_PROJECTS-01, and on the film strip it works. HERE IT DOES NOT, and the reason
      was measured on the Coniston V3 page at 375 pixels: the theme's own handler runs FIRST, one
      millisecond after the press, while this block's handler runs after it. So by the time this
      block wrote down "which photograph was showing", the theme had already moved the gallery on,
      and the note it wrote down was of the NEW photograph. Three hundred and fifty milliseconds
      later the check compared the gallery against that new photograph, found it unchanged, decided
      the theme had not answered, and moved the gallery a second time. The press still moved two
      photographs. On the film strip the theme answers with an animated glide that is still running
      when the check happens, which is why the same pattern is safe there and not here. This block
      therefore now stands aside completely: no wait, no second look, no move.

      WHAT WE LOSE BY HAVING NO NET, AND WHY THAT IS THE RIGHT TRADE. If the theme's own arrow code
      is ever broken again the way board task 237_PROJECTS-01 found it broken, the two arrows over
      the big photograph will stop working below 750 pixels until that breakage is repaired. That is
      a visible fault somebody will report, whereas a net that fires wrongly is a silent fault that
      moves the gallery twice on every press and took a shopper's report to notice.

      THE FILM STRIP'S OWN ARROWS ARE A DIFFERENT SET AND WERE NOT TOUCHED. Those are the small
      arrows beside the strip of little photographs below the big one, built under board tasks 190,
      191 and 242_PROJECTS-01, and they live in block 4 below. They sit inside a
      product-thumbnail-navigation element, while the two arrows over the big photograph sit inside
      a carousel-navigation element. Block 4 checks for product-thumbnail-navigation before it does
      anything, so it never answers a press on the big photograph's arrows and was never any part of
      this fault. Measured on the same page on 30 August 2026: the big photograph's forward arrow is
      inside a carousel-navigation element and is NOT inside any product-thumbnail-navigation
      element. */
(function () {
  function mediaIds(gallery) {
    return Array.prototype.slice
      .call(gallery.querySelectorAll('.product-media-thumbnail[data-media-id]'))
      .map(function (t) { return t.getAttribute('data-media-id'); });
  }
  function currentId(gallery) {
    var a = gallery.querySelector('.product-media-thumbnail.is-active[data-media-id]') ||
            gallery.querySelector('.product-media-main.is-active[data-media-id]') ||
            gallery.querySelector('.product-media-main.is-selected[data-media-id]');
    return a ? a.getAttribute('data-media-id') : null;
  }
  function step(gallery, delta) {
    var list = mediaIds(gallery);
    if (list.length < 2 || typeof gallery.setActiveMedia !== 'function') { return; }
    var i = list.indexOf(currentId(gallery));
    if (i === -1) { i = 0; }
    gallery.setActiveMedia(list[(i + delta + list.length) % list.length]);
  }
  /* 269_PROJECTS-01: the box the two arrows sit inside is the one the theme's sliding library is
     switched on for, so that box is where the answer to "is the theme driving?" is written. */
  function sliderBox(nav, gallery) {
    return (typeof nav.closest === 'function' && nav.closest('.product-media-main-wrapper')) ||
           gallery.querySelector('.product-media-main-wrapper');
  }
  function themeIsDriving(nav, gallery) {
    var box = sliderBox(nav, gallery);
    return !!(box && box.classList && box.classList.contains('flickity-enabled'));
  }
  /* 269_PROJECTS-01: while the theme's own sliding library is running the theme moves the picture
     itself, so this block does nothing whatsoever and one press moves one photograph. Calling
     preventDefault in both cases keeps this exactly as it behaved before, because the old code
     called it on every press too. */
  function pressed(event, nav, gallery, delta) {
    event.preventDefault();
    if (themeIsDriving(nav, gallery)) { return; }
    step(gallery, delta);
  }
  function wire() {
    var navs = document.querySelectorAll('carousel-navigation[for]');
    Array.prototype.forEach.call(navs, function (nav) {
      if (nav.getAttribute('data-ebd-wired') === '1') { return; }
      var gallery = document.getElementById(nav.getAttribute('for'));
      if (!gallery || typeof gallery.setActiveMedia !== 'function') { return; }
      var prev = nav.querySelector('.js-prev');
      var next = nav.querySelector('.js-next');
      if (prev) { prev.addEventListener('click', function (e) { pressed(e, nav, gallery, -1); }); }
      if (next) { next.addEventListener('click', function (e) { pressed(e, nav, gallery, 1); }); }
      nav.setAttribute('data-ebd-wired', '1');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  window.addEventListener('load', wire);
  setTimeout(wire, 1200);
  setTimeout(wire, 3000);
})();

/* 2) Delivery estimate in the stock bar. Sean's design, 29 August 2026, board entry
      187_PROJECTS-01. His two figures: the store dispatches within 24 to 48 hours, and the courier
      then takes 1 to 3 WORKING days. The theme's own wording stays in place as the fallback, so if
      this file ever fails the shopper still sees a true sentence instead of nothing.
      The bank holiday list is England and Wales, 2026 and 2027. IT MUST BE EXTENDED BEFORE
      JANUARY 2028 or the sums will quietly stop skipping holidays. */
(function () {
  var HOLIDAYS = ['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31',
    '2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31',
    '2027-08-30','2027-12-27','2027-12-28'];
  var DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function key(d) {
    var m = d.getMonth() + 1, n = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (n < 10 ? '0' + n : n);
  }
  function isHoliday(d) { return HOLIDAYS.indexOf(key(d)) !== -1; }
  function isWorking(d) { var w = d.getDay(); return w !== 0 && w !== 6 && !isHoliday(d); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function nextWorking(d) { var x = new Date(d.getTime()); while (!isWorking(x)) { x = addDays(x, 1); } return x; }
  function addWorking(d, n) { var x = new Date(d.getTime()); for (var i = 0; i < n; i++) { x = nextWorking(addDays(x, 1)); } return x; }
  function label(d) { return DAY[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; }
  function lines() {
    var today = new Date();
    var dispatch = nextWorking(addDays(today, 1));
    var earliest = addWorking(dispatch, 1);
    var latest = addWorking(dispatch, 3);
    var weekend = 0, holiday = 0;
    for (var d = new Date(today.getTime()); d <= latest; d = addDays(d, 1)) {
      var w = d.getDay();
      if (w === 0 || w === 6) { weekend++; } else if (isHoliday(d)) { holiday++; }
    }
    var allowing = '';
    if (weekend && holiday) { allowing = ', allowing for a weekend and a bank holiday'; }
    else if (weekend) { allowing = ', allowing for the weekend'; }
    else if (holiday) { allowing = ', allowing for a bank holiday'; }
    return ['Ships within 24 to 48 hours' + allowing,
            'Est. delivery: ' + label(earliest) + ' - ' + label(latest)];
  }
  function fill() {
    var caps = document.querySelectorAll('.stock-bar-status-in .stock-bar-status-caption');
    if (!caps.length) { return; }
    var t = lines();
    Array.prototype.forEach.call(caps, function (cap) {
      if (cap.getAttribute('data-ebd-delivery') === '1') { return; }
      var a = document.createElement('div');
      a.textContent = t[0];
      var b = document.createElement('div');
      b.textContent = t[1];
      b.style.fontWeight = '600';
      cap.textContent = '';
      cap.appendChild(a);
      cap.appendChild(b);
      cap.setAttribute('data-ebd-delivery', '1');
    });
  }
  /* 361_PROJECTS-01, 1 September 2026: WHY THE SECOND LINE WENT MISSING WHEN A SHOPPER PICKED A
     COLOUR. fill() above used to run only three times, all of them at page load. When a shopper
     picks a colour the theme fetches a fresh copy of the green stock box from Shopify and swaps it
     into the page, and that fresh copy carries neither the data-ebd-delivery mark nor the second
     line — fill() never ran again to fill it back in. The watcher below notices the page changing
     and calls fill() again, copying the same watching pattern block 6 below already uses to put its
     own button back after the buy column is rebuilt. It watches the whole page body, because the
     stock box can be rebuilt inside more than one container depending on the page, and fill() is
     cheap and safe to call as often as this watcher fires: it does nothing to a box that already
     carries the data-ebd-delivery mark. Nothing above this note — the wording, the working-day
     sums, the bank holiday list or the mark itself — is changed by this. */
  var deliveryScheduled = false;
  function fillSoon() {
    if (deliveryScheduled) { return; }
    deliveryScheduled = true;
    setTimeout(function () { deliveryScheduled = false; fill(); }, 0);
  }
  function watchDelivery() {
    if (typeof window.MutationObserver !== 'function') { return; }
    if (document.body.getAttribute('data-ebd-delivery-watched') === '1') { return; }
    new window.MutationObserver(fillSoon).observe(document.body, { childList: true, subtree: true });
    document.body.setAttribute('data-ebd-delivery-watched', '1');
  }
  function run() { fill(); watchDelivery(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  window.addEventListener('load', run);
  setTimeout(run, 1200);
})();

/* 3) RETIRED AND SWITCHED OFF ON 30 AUGUST 2026 — NOT DELETED. Board task 239_PROJECTS-01.
      Every line of the original block 3 is still here below, word for word, with two slashes
      put in front of each one so the browser ignores it. Taking those two slashes off every
      line brings the block straight back.

      WHAT BLOCK 3 USED TO DO. It looked for a click-to-open section on a product page headed
      "The E-Bike Centre Commitment", lifted it out of the stack of click-to-open sections below
      the big photo gallery, and dropped it into the buy column on the right, directly under
      Matthew Kesbey's "If you need assistance, before you buy" block.

      WHY IT NO LONGER DOES ANYTHING. On 29 August 2026, under board entry 223_PROJECTS-01, the
      Commitment stopped being a click-to-open section. It became plain always-open writing that
      the page's own settings file places in the buy column itself, inside the block
      div.product-info-details custom-liquid, and it carries no button of any kind. Block 3
      searches for a button whose words start with "The E-Bike Centre Commitment", finds none,
      and quietly gives up on every single page load.

      PROVED DEAD BEFORE IT WAS SWITCHED OFF. Measured on 30 August 2026 on the Coniston V3
      product page of the draft theme EBikeDepot v18d, at 1400 pixels of window width and again
      at 900. The page holds seven click-to-open sections — Features, Specifications, Size Guide,
      Shipping Information, Delivery & Returns, Warranty and Cycle to Work Scheme — and not one
      of them is the Commitment. Switching block 3 off therefore changes nothing a shopper sees.

      IT IS KEPT SO THE 29 AUGUST DECISION CAN BE UNDONE IN SECONDS. If the Commitment is ever
      made a click-to-open section again, take the two slashes off the lines below and it will
      move itself back under Matthew Kesbey exactly as it did before. */

// /* 3) THE E-BIKE CENTRE COMMITMENT SECTION MOVES UP UNDER MATTHEW KESBEY.
//       Sean's order of 29 August 2026 at 12:48, board task 218_PROJECTS-01, in his own words:
//       "let's add the E-Bike Centre Commitment underneath the Matthew container and above the
//       'need help choosing the right size' container with the social icon, so it sits in the
//       middle there."
//
//       WHAT THIS MOVES, AND WHERE FROM AND TO. A product page has ten click-to-open sections
//       stacked below the big photo gallery, inside div.product-info-description. One of them is
//       headed "The E-Bike Centre Commitment". This code lifts that one section out of that stack
//       and drops it into the buy column on the right, directly below Matthew Kesbey's
//       "If you need assistance, before you buy" block and directly above the "Need help choosing
//       the right size?" block that carries the three social share buttons. The other nine
//       sections are not touched and stay below the gallery.
//
//       WHY THIS IS DONE IN CODE AND NOT BY REORDERING THE PAGE'S OWN SETTINGS FILE. The theme
//       sorts a product page's blocks by their TYPE, not by the order they are listed in
//       templates/product.json. Every click-to-open section is of the type "expandable", and the
//       theme sends every expandable block to div.product-info-description without exception. So
//       changing the order in templates/product.json cannot put one of them in the buy column.
//       That was tested on the page on 29 August 2026 before this code was written.
//
//       HOW THE SECTION IS RECOGNISED — BY THE WORDS ON ITS BUTTON. These ten sections carry no id
//       and no class of their own; all ten were checked on the page on 29 August 2026 and every one
//       had an empty id and an empty class. The visible heading text on the button is therefore the
//       only thing that tells them apart. If Sean ever renames the section on the page, the first
//       few words below must be renamed to match or the section will simply stay where it is.
//
//       IT RUNS AT EVERY SCREEN WIDTH, on purpose. Sean asked for the section to sit under Matthew
//       everywhere. On a phone and on a tablet the page is one single stack rather than two
//       columns, so making the same move there still leaves the section directly under Matthew.
//
//       IT IS SAFE TO RUN OVER AND OVER. Before moving anything it checks whether the section is
//       already sitting directly after Matthew's block, and if it is, it does nothing at all. That
//       also means it repairs itself: if the theme rebuilds the buy column after a shopper picks a
//       different size or colour, the next run quietly puts the section back. Moving an element in
//       a page relocates the one element rather than copying it, so no repeat can ever produce two
//       copies of the section.
//
//       IT DOES NOTHING ON PAGES THAT ARE NOT THIS KIND OF PAGE. If either Matthew's block or the
//       Commitment section is missing — on the basket, on a blog post, on the home page — it stops
//       quietly instead of throwing an error. */
// (function () {
//   var HEADING = 'The E-Bike Centre Commitment';
//
//   function findSection() {
//     var buttons = document.querySelectorAll('button.facet-toggle');
//     for (var i = 0; i < buttons.length; i++) {
//       var text = (buttons[i].textContent || '').replace(/\s+/g, ' ').trim();
//       if (text.indexOf(HEADING) === 0) {
//         return buttons[i].closest('collapsible-expandable');
//       }
//     }
//     return null;
//   }
//
//   function findMatthewBlock() {
//     var details = document.querySelector('.product-contact-details-block');
//     return details ? details.closest('.product-block') : null;
//   }
//
//   function move() {
//     var section = findSection();
//     var matthew = findMatthewBlock();
//     if (!section || !matthew) { return; }
//     if (matthew.nextElementSibling === section) { return; }
//     matthew.insertAdjacentElement('afterend', section);
//   }
//
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', move);
//   } else {
//     move();
//   }
//   window.addEventListener('load', move);
//   setTimeout(move, 1200);
//   setTimeout(move, 3000);
// })();

/* 4) THE PHOTO-STRIP ARROWS ARE GIVEN A SAFETY NET SO THEY ALWAYS MOVE THE STRIP.
      Sean's report of 29 August 2026 at 13:26, board task 228_PROJECTS-01, in his own words:
      "down on the film strip of bicycle images I see that the arrows are not working at all."

      WHICH ARROWS THESE ARE. The two small square arrows sitting at the left and right ends of the
      strip of small bike photos below the big picture. They are drawn by the purchased theme's own
      custom element product-thumbnail-navigation, which is defined in assets/media-gallery.js.

      THE REAL CAUSE, FOUND AND MEASURED ON 29 AUGUST 2026 — AND IT IS OUR OWN CODE, NOT THE
      PURCHASED THEME'S. Below 990 pixels of window width the arrows are killed before they can do
      anything, by three scripts we wrote ourselves in July 2026. They live in the custom-liquid
      block named `logo-css` inside the theme file `sections/header-group.json`, and on the page they
      appear inside the section `shopify-section-sections--29709639057735__logo-css`. They are the
      three mobile rail-arrow injectors dated 16 July (task EB_978), 17 July (task EB_1036) and
      18 July 2026. Each one registers a click listener on the whole document IN THE CAPTURE PHASE,
      which means it sees every click before the button that was clicked does, and each one runs this:

          document.addEventListener("click", function (e) {
            if (window.innerWidth >= 990) return;
            var btn = e.target.closest(".js-prev,.js-next");   // ANY arrow on the whole page
            if (!btn) return;
            ...
            e.preventDefault();
            e.stopPropagation();                               // the click dies here
            var rail = sec.querySelector(".scroller-inner");
            if (!rail) return;                                 // ...and only NOW does it check
            ...
          }, true);

      WHY THAT KILLS THE PHOTO STRIP. The purchased theme names the gallery's own arrows with the very
      same two class names, js-prev and js-next. So below 990 pixels these three scripts grab the photo
      strip's arrows as well, stop the click dead, and only afterwards look for a rail called
      .scroller-inner to scroll. A product page has no such rail, so they give up and return — but the
      click has already been destroyed and can never reach the arrow. Both the photo strip arrows and
      the two arrows over the big picture are therefore completely dead below 990 pixels, which is
      exactly what Sean reported. Proved on the Coniston V3 page on 29 August 2026 at a 900 pixel wide
      window: a click on the forward arrow was seen arriving at the document but never reached the
      button, and the fault traced back to a stopPropagation call in that section.

      THE SECOND, SMALLER WEAKNESS, WHICH IS THE THEME'S OWN. The theme's next() method runs
      thumbnailWrapper.scroll(scrollLeft + 300, 0) on div.product-media-thumbnails, and prev() runs the
      same sum with 300 taken off. That is an ANIMATED scroll — a glide over roughly a third of a
      second rather than a jump — because assets/section-main-product.css sets scroll-behavior: smooth
      on .product-media-thumbnails from 750 pixels wide upwards. If that glide does not run, the strip
      does not move.

      WHAT THIS CODE ADDS, AND WHY IT IS ATTACHED WHERE IT IS. One listener on the whole document, also
      in the capture phase. It has to be on the document rather than on the arrow itself, because a
      click that has been stopped in the capture phase never reaches the arrow at all — a listener on
      the arrow would simply never run below 990 pixels. Stopping a click stops it travelling onward to
      other elements; it does NOT stop other listeners already sitting on the document, so this one
      still hears every click and can still move the strip.

      IT ONLY EVER TOUCHES THE PHOTO STRIP'S OWN TWO ARROWS. Before doing anything it checks that the
      clicked arrow sits inside a product-thumbnail-navigation element. The rail arrows those three
      July scripts legitimately drive are left completely alone.

      IT CANNOT EVER SCROLL TWICE, WHICH IS THE WHOLE POINT OF THE 350 MILLISECOND WAIT. It writes
      down where the strip was when the arrow was clicked, waits 350 milliseconds, and only then
      looks again. If the theme's own glide did start, the strip has moved by then, the check sees a
      changed position and this code does nothing whatsoever. The instant jump happens only when the
      strip has not moved by even one pixel. A glide begins on the very next frame drawn, about 16
      milliseconds, so 350 milliseconds is a generous margin.

      IT NEVER SCROLLS PAST EITHER END. The place it jumps to is held between 0 and
      scrollWidth minus clientWidth, which is the furthest any scrolling box can travel. If the strip
      is already at that end, the target equals where it started and no jump is made.

      IT KEEPS THE TWO ARROWS' AVAILABLE AND UNAVAILABLE LOOK IN STEP, copying the theme's own sums
      from media-gallery.js exactly: the back arrow is switched off within 30 pixels of the start and
      the forward arrow within 30 pixels of the end. The theme changes only the pill-nav-item-disabled
      class, which is what dims the arrow on screen, and leaves the aria-disabled label frozen at
      whatever the page was built with. This sets BOTH to the same answer, so software that reads the
      page aloud to a blind shopper says the same thing a sighted shopper sees.

      THE PROPER REPAIR STILL NEEDS DOING, AND IT IS NOT IN THIS FILE. What this code does is keep the
      photo strip working in spite of those three July scripts. It does not repair them, and they are
      still destroying clicks on every other page of the store below 990 pixels wide. The real repair
      is a one-line change inside the `logo-css` custom-liquid block of `sections/header-group.json`:
      each of the three scripts must find its rail FIRST and only call preventDefault and
      stopPropagation once it knows it actually has a rail to scroll. That file was not touched here
      because another Batch owned it on 29 August 2026.

      A MEASUREMENT NOTE, SO NOBODY IS MISLED BY A TEST RESULT. In the in-app Browser pane used to
      check this work, animated scrolling is switched off altogether: a brand-new scrolling box built
      from scratch on an unrelated page of this same store also refused to glide, and a plain CSS fade
      jumped straight to its finished state. So that pane cannot show whether the theme's own glide
      works in a normal browser, and a test there will always appear to need the instant jump below.
      The 990 pixel fault described above is a different matter entirely: it was proved by tracing a
      real click, and it does not depend on animation at all.

      IT DOES NOTHING ON PAGES THAT ARE NOT THIS KIND OF PAGE. If the strip or either arrow is
      missing it stops quietly instead of throwing an error. It is safe to run over and over: each
      set of arrows is stamped once wired, so no arrow is ever given the same listener twice. */
(function () {
  var SETTLE_MS = 350;
  var EDGE = 30;
  var STEP = 300;

  function stripOf(nav) {
    var gallery = document.getElementById(nav.getAttribute('for'));
    return gallery ? gallery.querySelector('.product-media-thumbnails') : null;
  }

  function isSideways(el) { return el.scrollWidth > el.clientWidth; }

  function positionOf(el) { return isSideways(el) ? el.scrollLeft : el.scrollTop; }

  function furthest(el) {
    return isSideways(el)
      ? el.scrollWidth - el.clientWidth
      : el.scrollHeight - el.clientHeight;
  }

  function jumpTo(el, target) {
    var kept = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
    if (isSideways(el)) { el.scrollLeft = target; } else { el.scrollTop = target; }
    el.style.scrollBehavior = kept;
  }

  function mark(button, switchedOff) {
    if (!button) { return; }
    if (switchedOff) { button.classList.add('pill-nav-item-disabled'); }
    else { button.classList.remove('pill-nav-item-disabled'); }
    button.setAttribute('aria-disabled', switchedOff ? 'true' : 'false');
  }

  function refresh(nav, el) {
    var here = positionOf(el);
    var end = furthest(el);
    mark(nav.querySelector('.js-prev'), here <= EDGE);
    mark(nav.querySelector('.js-next'), here >= end - EDGE);
  }

  function guard(nav, el, delta) {
    var before = positionOf(el);
    var target = Math.max(0, Math.min(furthest(el), before + delta));
    setTimeout(function () {
      if (target !== before && Math.abs(positionOf(el) - before) < 1) { jumpTo(el, target); }
      refresh(nav, el);
    }, SETTLE_MS);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') { return; }
    var button = target.closest('.js-prev, .js-next');
    if (!button) { return; }
    var nav = button.closest('product-thumbnail-navigation');
    if (!nav) { return; }
    var el = stripOf(nav);
    if (!el) { return; }
    guard(nav, el, button.classList.contains('js-prev') ? -STEP : STEP);
  }, true);

  function wireStrip(nav) {
    if (nav.getAttribute('data-ebd-strip-wired') === '1') { return; }
    var el = stripOf(nav);
    var prev = nav.querySelector('.js-prev');
    var next = nav.querySelector('.js-next');
    if (!el || !prev || !next) { return; }
    el.addEventListener('scroll', function () { refresh(nav, el); });
    refresh(nav, el);
    nav.setAttribute('data-ebd-strip-wired', '1');
  }

  function run() {
    Array.prototype.forEach.call(
      document.querySelectorAll('product-thumbnail-navigation[for]'),
      wireStrip
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 1200);
  setTimeout(run, 3000);
})();

/* 5) ON TABLET AND MOBILE THE BIKE'S INTRODUCTION PARAGRAPHS MOVE UP UNDER THE BIKE'S NAME.
      Sean's order of 29 August 2026 at 14:25, board task 235_PROJECTS-01, in his own words:
      "when we go to tablet and mobile the product intro paragraphs should be up here underneath
      the heading of the bike and above the three unique selling point block. This intro paragraph
      should not be down underneath the E-Bike Centre Commitment block when we go to tablet and
      mobile — it should be up."

      WHICH PARAGRAPHS THESE ARE. The two paragraphs of plain writing about the bike that begin
      "With updated specs, the Dallingridge Coniston delivers improved performance..." on the
      Coniston V3 page. On the page they are one div carrying the classes facet and
      facet-standalone, and they sit inside div.product-info-description-content, which is the
      area below the big photo gallery. They are the only block in that area with no title bar and
      no chevron to click, which is what "standalone" means there.

      WHERE THEY MOVE TO. Directly after the block holding the bike's name — div.product-info-main,
      the block that contains h1.product-info-heading — and therefore directly before the block of
      three green ticks, div.product-info-extra. That green-ticks block was measured on the page on
      29 August 2026 and is the very next block after the bike's name, so putting the paragraphs
      after the name automatically puts them before the ticks. Nothing else on the page is touched.

      IT ONLY EVER HAPPENS ON A NARROW SCREEN, AND THE WIDTH WAS MEASURED, NOT ASSUMED. The page
      turns from two columns into one single stack at exactly 990 pixels of window width. That was
      proved on this page on 29 August 2026 by measuring the photo gallery and the buy column at
      two widths one pixel apart: at 990 pixels the buy column started at 548 pixels across, to the
      right of the gallery which ended at 488, so they sat side by side; at 989 pixels both boxes
      started at 20 pixels across and were both 934 pixels wide, so they were stacked. The theme's
      own switch is therefore the media query (min-width: 990px), and this code asks the browser
      that exact question rather than counting pixels itself.

      THE WIDE SCREEN IS LEFT COMPLETELY ALONE. At 990 pixels and above this code puts the
      paragraphs back exactly where the theme built them — the first thing inside
      div.product-info-description-content, below the photo gallery and directly above the first
      click-to-open section — and it also takes off the marker attribute it adds, so the page's own
      markup on a wide screen is left exactly as the theme wrote it. If the window is never made
      narrow, this code moves nothing at all.

      IT FOLLOWS THE WINDOW BEING DRAGGED WIDER AND NARROWER, IN BOTH DIRECTIONS. It listens for the
      browser's own answer to that 990 pixel question changing, and it also listens for a plain
      window resize. Two listeners rather than one is deliberate: some preview panes change the
      page's size in a way that does not always announce a media query change, and doing the work
      twice costs nothing because of the next paragraph.

      IT CANNOT DUPLICATE THE PARAGRAPHS AND IT IS SAFE TO RUN OVER AND OVER. Moving an element
      inside a page relocates that one element rather than copying it, so no number of repeats can
      ever produce two copies. Before moving anything it checks whether the paragraphs are already
      in the right place and, if they are, does nothing whatsoever.

      HOW IT FINDS THE PARAGRAPHS AGAIN AFTER IT HAS MOVED THEM. Once moved they are stamped with
      the attribute data-ebd-intro="1", so the next run finds them by that stamp wherever they now
      sit. It also writes down which container they came out of and which position they held in it,
      so putting them back is exact rather than a guess. If that container is ever rebuilt by the
      theme, it falls back to the first position inside a freshly found
      div.product-info-description-content, which is where they were measured to be.

      IT DOES NOTHING ON A PAGE THAT HAS NO INTRODUCTION, AND LEAVES NO GAP. A bike with no
      introduction text stored against it has no facet-standalone block at all, and a block holding
      only empty space is ignored as well, so nothing is moved and no empty space appears where the
      paragraphs would have been. On the basket, a blog post or the home page the bike's name and
      the description area are both missing, so it stops quietly instead of throwing an error.

      IT DOES NOT FIGHT THE E-BIKE CENTRE COMMITMENT MOVE IN BLOCK 3 ABOVE. That block moves a
      different element — the Commitment section — to a different place, directly after Matthew
      Kesbey's block, which is far below the bike's name. Neither block reads or writes the other's
      element, and neither one's finished position is inside the other's. */
(function () {
  var WIDE = '(min-width: 990px)';
  var wide = window.matchMedia(WIDE);
  var home = null;

  function introBlock() {
    var moved = document.querySelector('[data-ebd-intro="1"]');
    if (moved && moved.isConnected) { return moved; }
    var content = document.querySelector('.product-info-description-content');
    if (!content) { return null; }
    var kids = content.children;
    for (var i = 0; i < kids.length; i++) {
      var kid = kids[i];
      if (kid.classList && kid.classList.contains('facet-standalone') &&
          (kid.textContent || '').trim() !== '') {
        return kid;
      }
    }
    return null;
  }

  function rememberHome(intro) {
    var parent = intro.parentElement;
    if (!parent || !parent.classList ||
        !parent.classList.contains('product-info-description-content')) { return; }
    home = { parent: parent, index: Array.prototype.indexOf.call(parent.children, intro) };
  }

  function nameBlock() {
    var heading = document.querySelector('h1.product-info-heading');
    return heading ? heading.closest('.product-block') : null;
  }

  function lift(intro) {
    var block = nameBlock();
    if (!block || !block.parentElement) { return; }
    if (block.nextElementSibling === intro) { return; }
    intro.setAttribute('data-ebd-intro', '1');
    block.insertAdjacentElement('afterend', intro);
  }

  function putBack(intro) {
    var parent = (home && home.parent && home.parent.isConnected)
      ? home.parent
      : document.querySelector('.product-info-description-content');
    if (!parent) { return; }
    if (intro.parentElement !== parent) {
      var index = (home && home.parent === parent) ? home.index : 0;
      parent.insertBefore(intro, parent.children[index] || null);
    }
    intro.removeAttribute('data-ebd-intro');
  }

  function place() {
    var intro = introBlock();
    if (!intro) { return; }
    rememberHome(intro);
    if (wide.matches) { putBack(intro); } else { lift(intro); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  window.addEventListener('load', place);
  window.addEventListener('resize', place);
  if (typeof wide.addEventListener === 'function') { wide.addEventListener('change', place); }
  else if (typeof wide.addListener === 'function') { wide.addListener(place); }
  setTimeout(place, 1200);
  setTimeout(place, 3000);
})();

/* 6) ONE PLAIN BUTTON UNDER "BUY WITH SHOP PAY" TELLS SHOPPERS THE STORE ALSO TAKES PAYPAL,
      GOOGLE PAY AND A CARD. Sean's decision of 30 August 2026 at 12:30, board task
      254_PROJECTS-01. The button's shape and the hiding of the link it replaces are in the block
      labelled 254_PROJECTS-01 in the file assets/ebd-custom.css; this block builds the button and
      passes its click on.

      THE FAULT SEAN REPORTED. On a bike's page a shopper sees only the purple "Buy with Shop Pay"
      button, so PayPal and Google Pay stay hidden behind a small grey link reading "More payment
      options" and most shoppers never learn the store takes them.

      WHY THERE IS NO REAL PAYPAL BUTTON AND NO REAL GOOGLE PAY BUTTON HERE. Shopify allows a product
      page exactly ONE wallet button and no setting can change that, which was proved under board task
      247_PROJECTS-01. Sean first proposed putting look-alike PayPal and Google Pay buttons on the page
      that simply lead onward, and at 12:30 on 30 August 2026 he chose the honest alternative instead,
      because a button carrying another company's logo that does not actually start that company's
      payment misuses their brand and misleads the shopper. So this is one button that SAYS the store
      takes them and leads to the page where the real ones live.

      WHAT THE SHOPPER SEES AND WHAT HAPPENS WHEN THEY PRESS IT. A see-through button with navy
      writing and a navy outline, the full width of the buy column, sitting directly below "Buy with
      Shop Pay", reading "Pay with PayPal, Google Pay or card". Pressing it takes the shopper to the
      store's own checkout page, which carries the real "Pay with PayPal" and "Pay with Google Pay"
      buttons. Read on the checkout page on 30 August 2026, both of those were present by name.

      HOW IT GETS THE SHOPPER THERE, AND WHY IT IS DONE THIS WAY RATHER THAN BY A WEB ADDRESS. The
      link already on the page is `<a id="more-payment-options-link" href="#">More payment options</a>`.
      Its address is just `#`, which goes NOWHERE — the link works only because Shopify's own code runs
      when it is clicked. A new button pointing at a web address would therefore not work at all, and
      any address written here would be an invention that could break the day Shopify changes how
      checkout starts. So the real link is left in the page and merely hidden from view, and this code
      passes the new button's click straight on to it. Shopify's own code does the actual work.

      A HIDDEN LINK STILL WORKS WHEN CLICKED BY CODE, AND THIS WAS PROVED RATHER THAN ASSUMED. On the
      Coniston V3 product page on 30 August 2026 the link was set to display: none and then clicked
      from code: the browser went to
      https://e-bikecentre.co.uk/checkouts/cn/hWNGFd1yhgaZz617VG9dyN75/en-ie, the store's checkout page.

      THE BUTTON IS BUILT FROM THE THEME'S OWN THREE CLASSES AND NOTHING ELSE. `button
      button-secondary button-outline` is the purchased Athens & Spoke theme's own outlined twin of the
      store's "Add to cart" button, which wears `button button-secondary`. Measured side by side on the
      Coniston V3 page on 30 August 2026, the two agree on height 42 pixels, corner rounding 2 pixels,
      outline rgb(0, 36, 125) at 1 pixel, font size 15 pixels, font weight 500 and inner padding
      12px 25px. No measurement, colour or spacing was designed here.

      IT CARRIES WORDS ONLY AND NO PAYPAL OR GOOGLE PAY LOGO, AND BOTH LEGITIMATE SOURCES WERE CHECKED
      FIRST ON 30 AUGUST 2026. Shopify's own official payment icons, rendered by the theme through
      snippets/main-product-payment-icons.liquid, offer six logos on this store — Visa, Mastercard,
      American Express, PayPal, Diners Club and Discover — so PayPal is available there but Google Pay
      is not. The theme's own snippets/icons.liquid holds 137 icons and not one is PayPal or Google Pay.
      Neither source gives BOTH logos, so no logo was drawn, copied or invented.

      IT IS MARKED type="button" ON PURPOSE. The button sits inside the page's own
      `<form action="/cart/add">`, and a button inside a form with no type set counts as a submit
      button, which would quietly add the bike to the basket when pressed. Setting the type to "button"
      stops that, so pressing it does one thing only: start the checkout.

      IT IS SAFE TO RUN OVER AND OVER, AND IT CANNOT PRODUCE TWO BUTTONS. Before building anything it
      looks for a button it has already made inside the buy area, and if that button is already sitting
      directly after "Buy with Shop Pay" it does nothing whatsoever.

      IT WAITS FOR SHOPIFY'S OWN BUTTON TO ARRIVE, AND IT REPAIRS ITSELF. Shopify's accelerated-checkout
      component is drawn after the rest of the page, and the theme rebuilds the buy column when a
      shopper picks a different size or colour. So as well as the usual four runs — as soon as the page
      is readable, once everything has loaded, and again after 1.2 and 3 seconds — this block watches
      the buy column for changes and puts the button back whenever the column is rebuilt. The watcher
      cannot chase its own tail: inserting the button makes the watcher run once more, and that run
      finds the button already in the right place and stops.

      IT SHOWS NOTHING IF THERE IS NOTHING TO CLICK. If the hidden "More payment options" link is
      missing — because Shopify's component failed to load, or on a page that is not a product page —
      no button is built at all, so a shopper is never shown a button that would do nothing. On the
      basket, a blog post or the home page it stops quietly instead of throwing an error.

      263_PROJECTS-01 — 30 AUGUST 2026 AT 13:15: THE WORDING CHANGED, AND THE WORDS NOW SIT IN THEIR
      OWN TAG SO THREE LOGOS CAN SIT UNDER THEM INSIDE THE SAME OUTLINE.

      THE NEW WORDING, WHICH IS SEAN'S OWN AND IS WRITTEN EXACTLY AS HE GAVE IT:
      "Pay with PayPal, Google Pay or Credit Card" — with a capital C on both Credit and Card. It
      replaces "Pay with PayPal, Google Pay or card". Every sentence above that quotes the older
      wording is history and is kept for the record, not a description of what is on screen now.

      THE WORDS ARE NOW WRAPPED IN THEIR OWN span CARRYING THE NAME ebd-alt-payment-label. Until
      today the words were written straight onto the button. They had to be given a tag of their own
      because block 7 below now puts a row of logos INSIDE this same button, and a button holding
      two things needs each of them to be a separate tag before it can stack one above the other.
      The 254_PROJECTS-01 block of assets/ebd-custom.css turns the button into that stack.

      THE BUTTON IS STILL THE THEME'S OWN THREE CLASSES AND NOTHING ELSE. Its outline, corner
      rounding, colours, font and inner padding are unchanged; only its height grows to fit the
      logos. The paragraph above beginning "IT CARRIES WORDS ONLY AND NO PAYPAL OR GOOGLE PAY LOGO"
      is SUPERSEDED — block 7 below records where each of the three logos now comes from.

      ============= 288_PROJECTS-01 — WHAT SEAN ORDERED AT 10:04 ON 31 AUGUST 2026 =============

      THE WORDS COME OFF THE SCREEN AND THE BUTTON KEEPS ONLY ITS LOGOS. Sean's order: remove the
      words "Pay with PayPal, Google Pay or Credit Card" from view, and keep the button, keep its
      outline, keep the row of logos and keep what happens when it is pressed. So the button is now
      an outlined box holding the seven payment marks and nothing else that can be seen.

      THE WORDS ARE HIDDEN, NOT DELETED, AND THE REASON IS A SHOPPER WHO CANNOT SEE. Software that
      reads a page aloud to a blind shopper announces a button by the words inside it. A button with
      no words at all announces nothing, so that shopper would be told there is a button and never
      told what it does — and the row of logos cannot fill the gap, because block 7 below marks it
      aria-hidden on purpose so the reading software skips it. The words therefore stay in the page,
      still reading exactly "Pay with PayPal, Google Pay or Credit Card", and are merely taken off
      the screen.

      THE THEME'S OWN NAME FOR "IN THE PAGE BUT NOT ON THE SCREEN" IS USED, AND NOTHING IS INVENTED.
      The purchased Athens & Spoke theme's own file assets/base.css declares `.visually-hidden` at
      line 1494, read from the draft theme on 31 August 2026: position absolute, width 1 pixel,
      height 1 pixel, margin minus 1 pixel, no padding, no border and clip rect(0 0 0 0). It is the
      theme's standing way of doing exactly this, and 56 elements on the live store already carry it
      — the "Regular price" and "Sale price" words beside every price are among them. The one word
      `visually-hidden` is added to the span below and NOT ONE new styling line is written anywhere.

      THE BUTTON CLOSES UP BY ITSELF AND NO HEIGHT IS SET BY HAND. `.visually-hidden` positions the
      words absolutely, which takes them out of the button's stack altogether, so the stack is left
      holding one thing — the row of logos — and a gap is only ever drawn BETWEEN two things. The
      `gap: 1rem` already written in the 254_PROJECTS-01 block of assets/ebd-custom.css therefore
      draws nothing, and no empty space is left where the words were. Every sentence above measuring
      the button at 76 pixels tall describes the button as it stood between 13:58 on 30 August 2026
      and 10:04 on 31 August 2026; the new height measured after this change is recorded on board
      task 288_PROJECTS-01.

      ========================================================================================== */
(function () {
  var LABEL = 'Pay with PayPal, Google Pay or Credit Card';
  var MARK = 'ebd-alt-payment-button';
  var scheduled = false;

  function buyArea() { return document.querySelector('.product-actions-buy-now'); }

  function hiddenLink(area) { return area.querySelector('#more-payment-options-link'); }

  /* 1439_EBC v1.0: follow this form's real purchase state, including variant changes. */
  function canBuy(area) {
    var form = area && area.closest('form');
    var submit = form && form.querySelector('button[name="add"]');
    return !!submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true';
  }

  function syncAvailability(button, area) {
    var unavailable = !canBuy(area);
    if (button.disabled !== unavailable) { button.disabled = unavailable; }
    if (button.hidden !== unavailable) { button.hidden = unavailable; }
    var state = unavailable ? 'true' : 'false';
    if (button.getAttribute('aria-disabled') !== state) { button.setAttribute('aria-disabled', state); }
  }

  function build() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button-secondary button-outline ' + MARK;
    var words = document.createElement('span');
    /* 288_PROJECTS-01, 31 August 2026 at 10:04: `visually-hidden` is the purchased theme's own name
       for words that stay in the page for a screen reader but are taken off the screen. */
    words.className = 'ebd-alt-payment-label visually-hidden';
    words.textContent = LABEL;
    button.appendChild(words);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var area = buyArea();
      var link = area ? hiddenLink(area) : null;
      if (link && canBuy(area)) { link.click(); }
    });
    return button;
  }

  function place() {
    var area = buyArea();
    if (!area) { return; }
    var payButton = area.querySelector('.shopify-payment-button');
    if (!payButton || !hiddenLink(area)) { return; }
    var button = area.querySelector('.' + MARK) || build();
    syncAvailability(button, area);
    if (payButton.nextElementSibling === button) { return; }
    payButton.insertAdjacentElement('afterend', button);
  }

  function soon() {
    if (scheduled) { return; }
    scheduled = true;
    setTimeout(function () { scheduled = false; place(); }, 0);
  }

  function watch() {
    var column = document.querySelector('.product-info');
    if (!column || column.getAttribute('data-ebd-alt-payment-watched') === '1') { return; }
    if (typeof window.MutationObserver !== 'function') { return; }
    new window.MutationObserver(soon).observe(column, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']
    });
    column.setAttribute('data-ebd-alt-payment-watched', '1');
  }

  function run() { place(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 1200);
  setTimeout(run, 3000);
})();

/* 7) SEVEN PAYMENT MARKS SIT INSIDE THE "PAY WITH PAYPAL, GOOGLE PAY OR CREDIT CARD" BUTTON, UNDER
      ITS WORDS AND WITHIN ITS OUTLINE, LAID OUT AS THREE COLUMNS. Board task 259_PROJECTS-01 of
      30 August 2026 at 13:00 first put a row of six logos UNDER the button; board task
      263_PROJECTS-01 of the same day at 13:15 replaced that with three marks and moved them INSIDE
      the button; board task 266_PROJECTS-01 of the same day at 13:58 replaced the plain credit-card
      outline with the real card brands and arranged all of them as three columns. The styling lines
      this needs are in the block labelled 259_PROJECTS-01 in the file assets/ebd-custom.css.

      ================ 266_PROJECTS-01 — WHAT SEAN ORDERED AT 13:58 ON 30 AUGUST 2026 ===============

      HE LOOKED AT THE BUTTON AND SAID THE ACTUAL CARD BRANDS WERE MISSING. In his own words he asked
      for the row of card-brand logos that sits in the page footer to be put back into the button in
      place of the plain credit-card outline, and for the inside of the button to be arranged as a
      small table: one full-width row on top carrying the words, and THREE columns beneath it.

      WHAT IS IN EACH OF THE THREE COLUMNS.
        column 1   PayPal
        column 2   Google Pay
        column 3   Visa, Mastercard, American Express, Diners Club and Discover

      WHY PAYPAL IS LEFT OUT OF COLUMN 3. The footer's own row holds SIX logos and PayPal is one of
      them. PayPal already stands alone in column 1, so showing it again in column 3 would show the
      same brand twice in one button. Sean asked for it to be left out of the strip for that reason.

      THE PLAIN CREDIT-CARD OUTLINE IS DELETED. Between 13:15 and 13:58 on 30 August 2026 column 3
      held a single line-drawing of a card, copied out of the purchased theme's own file
      snippets/icons.liquid where it is named icon-credit-card. Sean asked for it to go once the real
      card brands were back, so the CREDIT_CARD drawing that used to sit in this block is removed and
      nothing in this file refers to it any more. Paragraph 3 of the 263_PROJECTS-01 note below, which
      described where that drawing came from, is SUPERSEDED and is kept only as history.

      ALL SIX COPIED PICTURES COME FROM THE FOOTER'S OWN ROW, EXACTLY AS BOARD TASK 259_PROJECTS-01
      TOOK THEM. Nothing is drawn, downloaded or invented here. Each one is found in the footer row by
      the spoken name Shopify writes into it — Visa, Mastercard, American Express, PayPal, Diners Club
      and Discover, all read off the store on 30 August 2026 — so no position or order is assumed and
      the marks in the button can never disagree with the marks in the footer.

      EVERY COPY GETS FRESH NAMES, AND THE COUNTER IS NOW SHARED BETWEEN THEM. Until today only the
      PayPal picture was copied, so the renaming counter could safely start again at 1 on every call.
      With six pictures copied, a counter that restarted would have handed the same fresh name to more
      than one of them and re-created the very fault the renaming exists to prevent. The counter is
      therefore now held once for the whole file, at `renamed` below, and it never restarts.

      THE WHOLE ROW STILL FITS ON ONE LINE ON A PHONE, AND THIS WAS MEASURED BEFORE IT WAS BUILT. On
      the EMU E-Haul product page on 30 August 2026 at a 400 pixel wide window: the button is 370
      pixels wide and 76 pixels tall, the row of seven marks is 325 pixels wide and 24 pixels tall,
      and there are 22.5 pixels of clear space between the outermost mark and each side of the
      button's outline. Nothing wraps, nothing spills outside the outline and the button's height is
      unchanged. The page's own width did not grow either — it read 400 pixels, the same as the
      window, so no sideways scrolling was introduced.

      ==============================================================================================

      ================ 263_PROJECTS-01 — WHAT SEAN ORDERED AT 13:15 ON 30 AUGUST 2026 ================

      Four things, in his own words: the logos move inside the button's outline so the button becomes
      one taller box holding its text and its logos together; the wording reads exactly "Pay with
      PayPal, Google Pay or Credit Card"; only THREE logos show, in the order PayPal, Google Pay,
      credit card; and the Google Pay logo, which was missing, is to be found and shown.

      WHERE EACH OF THE THREE LOGOS COMES FROM. Not one was drawn, traced or approximated.

      1. PAYPAL — SHOPIFY'S OWN OFFICIAL ARTWORK, TAKEN OFF THIS VERY PAGE. The theme already draws a
         row of payment logos at the bottom of the footer, built by Shopify's own instruction
         `payment_type_svg_tag` in sections/footer.liquid. This block finds the PayPal picture in that
         row by its own spoken name and copies it. Same artwork, same 38 by 24 pixel size, nothing
         remade.

      2. GOOGLE PAY — GOOGLE'S OWN OFFICIAL ARTWORK, READ FROM GOOGLE'S OWN ADDRESS, UNALTERED. The
         file is https://www.gstatic.com/instantbuy/svg/light_gpay.svg, served by gstatic.com, which
         is Google's own address for the pictures its products use. Read on 30 August 2026: 1,820
         bytes, content type image/svg+xml. It is the four-colour Google G followed by the word Pay
         in Google's own grey, and the drawing below is that file's own drawing instructions copied
         character for character.

         GOOGLE'S PERMISSION WAS READ FIRST, AND IT IS QUOTED HERE. Google's brand guidelines at
         https://developers.google.com/pay/api/web/guides/brand-guidelines say: "Use only the Google
         Pay mark that's provided in these guidelines when you show Google Pay as an option in your
         payment flows", and "Don't create your own mark or alter it in any way." Showing the mark to
         say a shop accepts Google Pay is exactly the use those guidelines describe. Nothing here
         creates a mark and nothing alters one.

         THE ONE THING ADDED TO GOOGLE'S FILE, AND WHY IT IS NOT AN ALTERATION. Google's own file
         carries no viewBox, which is the instruction that lets a drawing be shown at a different
         size without being cut off. A viewBox of "0 0 41.285 18" is written below — those are the
         exact dimensions of the outer boundary already inside Google's own file, so the drawing is
         unchanged and merely becomes resizable. Not one line, colour or proportion of the mark is
         touched, and the width and height below keep its own shape so it can never be stretched.

         WHY SHOPIFY'S ARTWORK WAS NOT USED FOR THIS ONE, CHECKED FIRST ON 30 AUGUST 2026. Shopify's
         theme-side payment pictures come from the store's own list of enabled payment types, and on
         this store that list holds exactly six names — visa, master, american_express, paypal,
         diners_club and discover. Google Pay is not one of them, so Shopify's own instruction cannot
         produce it here. Shopify does hold official Google Pay artwork, but only inside its checkout
         extension component, which runs in Shopify's own checkout and cannot be used from a theme
         file. Both were checked before Google's own artwork was used.

      3. THE CREDIT CARD — THE PURCHASED THEME'S OWN ICON, COPIED OUT OF THE THEME ITSELF. The Athens
         & Spoke theme's own file snippets/icons.liquid holds a plain credit-card drawing, found on
         line 673 on 30 August 2026 and named icon-credit-card. The drawing below is that icon's own
         instructions copied word for word, so this is pure reuse of the theme and no card brand's
         logo is used to stand for "a credit card". It is drawn in currentColor, which means it takes
         the button's own navy writing colour automatically and can never disagree with it.

      A CLICK ON A LOGO REACHES THE CHECKOUT, BECAUSE THE LOGOS ARE NOT BUTTONS. The row is marked
      pointer-events: none in the 259_PROJECTS-01 block of assets/ebd-custom.css, so a press on any
      of the three pictures passes straight through to the button holding them. The row is also
      marked aria-hidden so that software reading the page aloud to a blind shopper says the button's
      words once rather than reciting three picture names after them.

      THE ROW IS BUILT FROM span TAGS RATHER THAN A LIST, ON PURPOSE. It now lives INSIDE a button,
      and the rules of a web page do not allow a list inside a button. It still carries the theme's
      own two class names `list-inline-menu list-payment`, so it still takes its side-by-side
      arrangement, its 1rem gap, its centring and its wrapping from the theme's own assets/base.css
      exactly as the six-logo row did.

      EVERY PARAGRAPH BELOW THIS LINE DESCRIBES THE SIX-LOGO ROW OF 259_PROJECTS-01 THAT THIS
      REPLACED. It is kept whole as the record of what was there between 13:00 and 13:15 on 30 August
      2026, and it is NOT a description of what is on the page now.

      ==============================================================================================

      WHAT SEAN ASKED FOR. Block 6 above built a button reading "Pay with PayPal, Google Pay or card"
      under board task 254_PROJECTS-01, and that button carries words only. Sean asked for the store's
      official payment logos to sit under it, so a shopper can SEE the ways they may pay instead of
      only reading about them.

      NOT ONE LOGO WAS DRAWN, DOWNLOADED OR INVENTED. The purchased Athens & Spoke theme already draws
      a row of payment logos on this very page, at the bottom of the footer. This block finds that row
      and puts a COPY of it under the button. The artwork is therefore Shopify's own official payment
      artwork, exactly as the theme already draws it, and nothing here creates a picture of any kind.

      WHERE THE ROW IS COPIED FROM, AND WHY THAT IS ALLOWED. The row lives in the file
      sections/footer.liquid inside `<div class="footer-info-end">`, as
      `<ul class="list-inline-menu list-payment">`. The footer sits at the bottom of EVERY page of the
      store, so on a bike's page the row is genuinely already on the shopper's screen — it is simply a
      long way down. Copying it upward puts the same six logos where the shopper is deciding to buy.
      Counted on the Coniston V3 page on 30 August 2026 there is exactly ONE such row on the page.

      THE SIX LOGOS, IN THE THEME'S OWN ORDER. Visa, Mastercard, American Express, PayPal, Diners Club
      and Discover. That list is not chosen here and is not trimmed here — it is whatever the footer
      row holds, in whatever order it holds it, so the logos under the button can never disagree with
      the logos in the footer. Read from the page on 30 August 2026, all six were present and named.

      GOOGLE PAY IS NOT AMONG THEM, AND SEAN KNOWS. Shopify's payment artwork on this store offers no
      Google Pay logo, and the theme's own file snippets/icons.liquid holds 137 icons of which none is
      Google Pay. Sean was told this at 13:00 on 30 August 2026 and chose to add the logos the store
      actually has. Google Pay therefore stays a word inside the button's text above.

      WHERE THE SIX LOGOS THEMSELVES COME FROM. The footer row is built by Shopify's own
      `payment_type_svg_tag`, the same instruction the theme uses in its file
      snippets/main-product-payment-icons.liquid. In sections/footer.liquid the six names are held in a
      fixed list rather than read from the store's live payment settings, under a note Sean left on
      15 July 2026 saying the fixed list stands until Shopify Payments is switched on with the MKSG
      company details. This block does not touch that arrangement; it copies whatever the row shows.

      NOT ONE SIZE, GAP OR POSITION IS CHOSEN HERE. Because the copy keeps the theme's own two class
      names `list-inline-menu list-payment`, the theme's own file assets/base.css goes on styling it:
      `.list-payment` gives it a row that centres itself, a 1rem gap between logos, and permission to
      wrap onto a second line, and each logo carries its own width of 38 and height of 24 written by
      Shopify. Measured on the Coniston V3 page on 30 August 2026, the copy under the button and the
      original row in the footer agree exactly: six logos, each 38 by 24 pixels, 10 pixels apart,
      278 pixels of logos in total, 24 pixels tall, on one line at window widths of 1400, 900 and 400.

      EVERY IDENTIFIER INSIDE THE COPY IS RENAMED, AND THAT IS NOT TIDINESS BUT A REAL FAULT AVOIDED.
      Two of the six logos are painted with a colour gradient that the artwork refers to by name, and
      each logo's spoken name is held in a tag with a name of its own — eight named parts in all. A
      page may not hold the same name twice: if it does, the browser hands both users of that name the
      FIRST one it finds, so the footer's own logo would start borrowing the copy's paint. Every name
      inside the copy is therefore given a fresh one, and every mention of the old name inside the copy
      is repointed to the new one. Proved on 30 August 2026: with the copy on the page, the page held
      no repeated name that it did not already hold without the copy, the copy's two gradient mentions
      both found their new names, and the footer's own row still showed all six of its logos.

      IT SHOWS NOTHING IF THERE IS NOTHING TO COPY. If the footer row is absent — because Sean turns
      the footer's payment setting off, or on a page that has no such row — no copy is made and nothing
      is added. It also does nothing until block 6 above has built its button, so the logos can never
      appear on their own with no button over them.

      IT IS SAFE TO RUN OVER AND OVER, AND IT CANNOT PRODUCE TWO ROWS. Before copying anything it looks
      for a copy it has already made inside the buy area, and if that copy is already sitting directly
      after the button it does nothing whatsoever.

      IT WAITS, AND IT REPAIRS ITSELF, FOR THE SAME REASON BLOCK 6 DOES. The theme rebuilds the buy
      column when a shopper picks a different size or colour, which would throw the copy away. So this
      block runs as soon as the page is readable, once everything has loaded, again after 1.2 and
      3 seconds, and it watches the buy column and puts the row back whenever the column is rebuilt.
      The watcher cannot chase its own tail: adding the row makes the watcher run once more, and that
      run finds the row already in the right place and stops.

      NO MINTED SECTION ID IS USED, so this survives the next theme duplicate. `.product-actions-buy-now`,
      `.footer-info-end` and `.list-payment` are all stable names that do not change when Shopify
      duplicates a theme. This obeys section 7 Rule A of PR_2_PROJECT_FACTS.md.

      THIS REUSES THE THEME RATHER THAN INVENTING, WHICH IS THE TEST SECTION 3 SETS. Section 3 of
      PR_2_PROJECT_FACTS.md forbids anything new unless Sean gives express written permission AND
      nothing already in the theme can be reused. Sean gave that permission at 13:00 on 30 August 2026,
      and the second half is met outright: the logos, their artwork, their size, their spacing and
      their centring are all the theme's own, copied and not remade. */
(function () {
  var MARK = 'ebd-alt-payment-logos';
  var scheduled = false;

  /* Google's own Google Pay mark. Read on 30 August 2026 from Google's own address
     https://www.gstatic.com/instantbuy/svg/light_gpay.svg and copied unaltered, save for the
     viewBox, width and height that let it be shown at the size of the logos beside it without
     being cut off or stretched. Google's brand guidelines permit a shop to show this mark to say
     it accepts Google Pay: https://developers.google.com/pay/api/web/guides/brand-guidelines */
  var GOOGLE_PAY =
    '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.285 18" width="37" height="16" focusable="false">' +
    '<g fill="none" fill-rule="evenodd">' +
    '<path d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zm7.668 2.287c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568m11.853.262l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z" fill="#5F6368"/>' +
    '<path d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" fill="#4285F4"/>' +
    '<path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703" fill="#34A853"/>' +
    '<path d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z" fill="#FABB05"/>' +
    '<path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" fill="#E94235"/>' +
    '<path d="M0 0h41.285v18H0z"/>' +
    '</g></svg>';

  /* 266_PROJECTS-01, 30 August 2026 at 13:58: the plain credit-card outline drawing that used to sit
     here is DELETED on Sean's order, because the real card brands now stand in its place. It was the
     purchased theme's own icon-credit-card from snippets/icons.liquid. Nothing refers to it now. */

  /* The five card brands that go in column 3, named by the spoken name Shopify writes into each
     picture in the footer's own row. PayPal is deliberately NOT in this list: it already stands
     alone in column 1, and Sean asked for it to be left out of the strip so no brand shows twice. */
  var CARD_BRANDS = ['visa', 'mastercard', 'american express', 'diners club', 'discover'];

  /* Counts the fresh names handed out to copied pictures. It is held here, once for the whole
     block, rather than inside the renaming function, so that six copies can never be given the
     same fresh name. It never restarts. */
  var renamed = 0;

  function buyArea() { return document.querySelector('.product-actions-buy-now'); }

  function sourceRow() { return document.querySelector('.footer-info-end ul.list-payment'); }

  /* Finds one named picture inside the theme's own footer row of payment logos and hands back a
     copy of it. The row is found by the theme's own stable class names, and the picture inside it
     by the spoken name Shopify writes into every one of them, so no position or order is assumed. */
  function logoFromFooter(spokenName) {
    var row = sourceRow();
    if (!row) { return null; }
    var titles = row.getElementsByTagName('title');
    for (var i = 0; i < titles.length; i++) {
      if ((titles[i].textContent || '').trim().toLowerCase() === spokenName) {
        var picture = titles[i].parentNode;
        while (picture && String(picture.nodeName).toLowerCase() !== 'svg') {
          picture = picture.parentNode;
        }
        return picture ? picture.cloneNode(true) : null;
      }
    }
    return null;
  }

  /* Wraps one picture in the theme's own list-payment-item tag so it takes the theme's own sizing
     and spacing. A span is used rather than a list item because this row now sits inside a button,
     and the rules of a web page do not allow a list inside a button. */
  function slot(picture) {
    var item = document.createElement('span');
    item.className = 'list-payment-item';
    if (typeof picture === 'string') { item.innerHTML = picture; }
    else { item.appendChild(picture); }
    return item;
  }

  /* Builds ONE of the three columns. Every picture handed to it is put in the theme's own
     list-payment-item wrapper, and every picture that is a COPY taken off the page is given fresh
     names first. A picture that could not be found is skipped, so a missing one never empties the
     whole column. 266_PROJECTS-01, 30 August 2026. */
  function column(pictures) {
    var cell = document.createElement('span');
    cell.className = 'ebd-alt-payment-col';
    pictures.forEach(function (picture) {
      if (!picture) { return; }
      if (typeof picture !== 'string') { rename(picture); }
      cell.appendChild(slot(picture));
    });
    return cell;
  }

  /* Builds the inside of the button as the three columns Sean asked for at 13:58 on 30 August 2026:
     PayPal on its own, then Google Pay on its own, then the footer's own strip of five card brands.
     If the footer row is missing, the copied pictures are simply left out and Google Pay still
     shows, rather than the whole row disappearing. 266_PROJECTS-01. */
  function build() {
    var row = document.createElement('span');
    row.className = 'list-inline-menu list-payment ' + MARK;
    row.setAttribute('aria-hidden', 'true');
    row.appendChild(column([logoFromFooter('paypal')]));
    row.appendChild(column([GOOGLE_PAY]));
    row.appendChild(column(CARD_BRANDS.map(logoFromFooter)));
    return row;
  }

  /* Gives every named part inside the copy a fresh name, and repoints every mention of the old
     name that sits inside the copy, so the copy and the footer's own row never share a name.
     266_PROJECTS-01, 30 August 2026: the counter it draws its fresh names from now lives outside
     this function, at `renamed` near the top of this block, so that the six copies this block now
     makes are numbered one after another instead of every one of them starting again at 1. */
  function rename(copy) {
    var map = {};
    [].forEach.call(copy.querySelectorAll('[id]'), function (element) {
      var was = element.getAttribute('id');
      if (!was) { return; }
      map[was] = MARK + '-' + (++renamed);
      element.setAttribute('id', map[was]);
    });
    [].forEach.call(copy.querySelectorAll('*'), function (element) {
      [].forEach.call(element.attributes, function (attribute) {
        var value = attribute.value;
        var changed = value;
        if (attribute.name === 'aria-labelledby' || attribute.name === 'aria-describedby') {
          changed = value.split(/\s+/).map(function (name) { return map[name] || name; }).join(' ');
        } else if (value.indexOf('#') !== -1) {
          Object.keys(map).forEach(function (was) {
            changed = changed.split('#' + was + ')').join('#' + map[was] + ')');
            if (changed === '#' + was) { changed = '#' + map[was]; }
          });
        }
        if (changed !== value) { attribute.value = changed; }
      });
    });
  }

  /* Puts the row of three logos INSIDE the button, as the last thing in it, so it sits under the
     button's words and within the button's own outline. It does nothing at all if the row is
     already there, so it is safe to run over and over and can never produce two rows. */
  function place() {
    var area = buyArea();
    if (!area) { return; }
    var button = area.querySelector('.ebd-alt-payment-button');
    if (!button) { return; }
    if (button.querySelector('.' + MARK)) { return; }
    /* Between 13:00 and 13:15 on 30 August 2026 the row sat OUTSIDE the button, directly after it.
       If a row from that arrangement is still on the page, it is taken away before the new one is
       put in, so a shopper can never be shown both. */
    var stray = area.querySelector('.' + MARK);
    if (stray && stray.parentNode) { stray.parentNode.removeChild(stray); }
    button.appendChild(build());
  }

  function soon() {
    if (scheduled) { return; }
    scheduled = true;
    setTimeout(function () { scheduled = false; place(); }, 0);
  }

  function watch() {
    var column = document.querySelector('.product-info');
    if (!column || column.getAttribute('data-ebd-payment-logos-watched') === '1') { return; }
    if (typeof window.MutationObserver !== 'function') { return; }
    new window.MutationObserver(soon).observe(column, { childList: true, subtree: true });
    column.setAttribute('data-ebd-payment-logos-watched', '1');
  }

  function run() { place(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 1200);
  setTimeout(run, 3000);
})();

/* 8) ON A PHONE THE BIG PRODUCT PHOTOGRAPH SLIDES ACROSS IN A QUARTER OF A SECOND INSTEAD OF
      THREE QUARTERS. Board task 277_PROJECTS-01.

      SEAN'S EXPRESS WRITTEN PERMISSION, GIVEN AT 08:26 ON 31 AUGUST 2026. He put his own product
      page beside a competitor selling the very same bike and said: "Let's try all of the above and
      see if it improves our Product Image Scroll / Display and gets it to look similar to" the Bike
      Yard Online page. Section 3 of PR_2_PROJECT_FACTS.md forbids altering any styling or movement
      without Sean's express written permission; those words are that permission.

      THE PAGE HE ASKED US TO RESEMBLE, read on 31 August 2026:
      https://www.bikeyardonline.co.uk/collections/dallingridge-electric-bikes/products/dallingridge-coniston-v3-hardtail-electric-mountain-bike-250w
      Their gallery finishes its move about 202 milliseconds after the press.

      WHAT WAS WRONG. On a phone the purchased Athens & Spoke theme drives the big product photograph
      with the Flickity library, and Flickity does not move a photograph for a set length of time. It
      throws the photograph and then lets it coast to a stop, the way a ball rolls. With the theme's
      settings the coasting takes a very long time to die away. Measured on the Dallingridge Coniston
      V3 product page of the draft theme EBikeDepot v18d at a 375 pixel wide window on 31 August 2026,
      with the browser window genuinely on screen so the movement ran at full speed:

        half way across                     133 milliseconds after the press
        95 per cent of the way across       401 milliseconds
        within one pixel of its final place  648 milliseconds
        99.9 per cent of the way across     737 milliseconds

      So a shopper sees the photograph shoot most of the way over in four tenths of a second and then
      crawl the last few pixels for another quarter of a second. That crawl is what makes it feel slow.

      WHAT THIS BLOCK CHANGES — TWO NUMBERS, AND NOTHING ELSE AT ALL.

        friction            0.28  ->  0.33     how quickly the coasting dies away
        selectedAttraction  0.025 ->  0.05     how strongly the photograph is pulled to its place

      Nothing else about the gallery is touched. The photographs, their order, their size, the arrows,
      the film strip underneath and the finger-dragging all stay exactly as the theme built them.

      THE TWO NUMBERS WERE FOUND BY MEASURING ON THE REAL PAGE, NOT CHOSEN BY TASTE. Six pairs were
      tried on the Coniston V3 page at 375 pixels on 31 August 2026 and each was timed three times.
      The figure below is the time from the press until the photograph is within one pixel of where it
      finally stops, which is the point a person can no longer see it moving:

        friction 0.28, attraction 0.025   648, 640, 649 milliseconds   (the theme's own settings)
        friction 0.32, attraction 0.045   286, 285, 276
        friction 0.33, attraction 0.05    241, 239, 238   <- chosen
        friction 0.35, attraction 0.055   238, 247, 238

      0.33 and 0.05 land on 239 milliseconds, which is the "about 250" Sean's task asked for and is
      within forty milliseconds of the Bike Yard Online page. Faster pairs were tried too and rejected:
      friction 0.5 with attraction 0.15 finished in 97 milliseconds, which reads as a snap rather than
      a slide and throws away the sense of the photographs being a strip you are moving along.

      IT ONLY EVER TOUCHES THE PRODUCT PHOTOGRAPH GALLERY. The store uses this same library elsewhere,
      including the moving pictures on the home page. This block finds its gallery by the purchased
      theme's own stable name div.product-media-main-wrapper and hands the two numbers to that one
      carousel only, so nothing else on the store changes speed.

      NOTHING HAPPENS ON A DESKTOP, WHICH IS CORRECT AND DELIBERATE. The theme switches this library
      off on wider screens, and there is then no Flickity carousel here for this block to find, so it
      quietly does nothing. Measured on 31 August 2026, the library is running at 375 pixels and is
      switched off at 900 and at 1400 pixels. Desktop is handled instead by the 277_PROJECTS-01 block
      in assets/ebd-custom.css, which dissolves one photograph into the next in 200 milliseconds.

      IT DOES NOT DISTURB BLOCK 1 ABOVE. Block 1 stands aside whenever this library is running, and it
      decides that by reading the name flickity-enabled off the very same box. This block never adds or
      removes that name and never touches an arrow; it only writes two numbers onto the carousel. One
      press still moves exactly one photograph.

      IT RE-APPLIES ITSELF, AND IT HAS TO. The theme creates this carousel fresh whenever the window
      crosses the width where it switches the sliding on and off, and a fresh carousel starts with the
      library's own default numbers again. So this block runs on the same schedule the other blocks in
      this file use, and it also watches that one box for the name flickity-enabled appearing, and sets
      the two numbers again each time a new carousel turns up.

      IT FAILS SILENTLY AND CHANGES NOTHING IF ANYTHING IS MISSING. If the library is absent, if the
      gallery is absent, or if the carousel has not been built yet, this block does nothing at all. It
      never throws an error, so it can never stop any other script on the page from running.

      NO MINTED SECTION ID IS USED, so this survives the next theme duplicate.
      .product-media-main-wrapper is the purchased theme's own stable name, which Shopify does not
      rewrite when a theme is duplicated. This obeys section 7 Rule A of PR_2_PROJECT_FACTS.md. */
(function () {
  /* The two numbers measured above. They are the only things this block writes. */
  var FRICTION = 0.33;
  var ATTRACTION = 0.05;

  function gallery() {
    return document.querySelector('.product-media-main-wrapper');
  }

  /* Hands back the carousel the theme built on that box, or null if there is not one. Everything is
     wrapped up, so a missing library or a changed library cannot throw. */
  function carousel(box) {
    try {
      if (!box || !window.Flickity || typeof window.Flickity.data !== 'function') { return null; }
      return window.Flickity.data(box) || null;
    } catch (e) {
      return null;
    }
  }

  function apply() {
    try {
      var box = gallery();
      var flkty = carousel(box);
      if (!flkty || !flkty.options) { return; }
      if (flkty.options.friction === FRICTION && flkty.options.selectedAttraction === ATTRACTION) { return; }
      flkty.options.friction = FRICTION;
      flkty.options.selectedAttraction = ATTRACTION;
    } catch (e) {
      /* Somebody else's library. If it ever changes shape, leave the gallery alone. */
    }
  }

  /* Watches the one box for the name flickity-enabled arriving, which is how the page says a new
     carousel has just been built. Only the class attribute of that single box is watched, so this
     costs nothing on a busy page. */
  function watch() {
    try {
      var box = gallery();
      if (!box || box.getAttribute('data-ebd-slide-speed-watched') === '1') { return; }
      if (typeof window.MutationObserver !== 'function') { return; }
      new window.MutationObserver(apply).observe(box, { attributes: true, attributeFilter: ['class'] });
      box.setAttribute('data-ebd-slide-speed-watched', '1');
    } catch (e) {
      /* No watcher is better than a broken page. The timed runs below still cover the common case. */
    }
  }

  function run() { apply(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  window.addEventListener('resize', run);
  setTimeout(run, 1200);
  setTimeout(run, 3000);
})();

/* 9) THE "FOLLOWING ON SHOP" BUTTON IN THE FOOTER IS READ IN WHITE INSTEAD OF BLACK.
      Board task 275_PROJECTS-01.

      SEAN GAVE PERMISSION FOR THIS EXACT APPROACH AT 08:32 ON 31 AUGUST 2026.

      WHAT WAS WRONG. In the navy band at the foot of every page there is a button reading "Following
      on Shop" with the Shop wordmark beside it. Its writing is pure black, rgb(0, 0, 0), sitting on
      navy, rgb(0, 36, 125). That is a contrast of 1.55 to 1, where ordinary writing needs 4.5 to 1 to
      be considered readable. White writing on that same navy measures 13.56 to 1. Sean said it barely
      reads, and the measurements agree with him.

      WHY THE ORDINARY WAYS DO NOT WORK, ESTABLISHED BY BATCH 130 ON 31 AUGUST 2026. The button is put
      on the page by one line in the theme file sections/footer.liquid,
      {{ shop | login_button: action: 'follow' }}, and Shopify then builds the button inside a sealed
      compartment of the page — a private area of its own that the page's ordinary stylesheets cannot
      see into. Five separate routes were tried and every one of them failed:

        - there is no theme setting for its colour; the theme offers only an on and off tick box
          named enable_follow_on_shop
        - the button publishes no styling handle, so the usual way of reaching into a sealed
          component has nothing to aim at
        - a stylesheet cannot reach the writing; four attempts, including forcing them, left it black
        - the button accepts no colour attribute; it watches only client-id, dev-mode, following and
          storefront-origin
        - there is no colour variable to override; Shopify writes the black in directly, and the only
          variable there controls see-through-ness, so overriding it would fade the writing away
          rather than turn it white

      THE ONE THING THAT DOES WORK, AND WHAT THIS BLOCK DOES. The sealed compartment is an open one,
      which means a script is allowed to reach inside it and add a stylesheet of its own. Read on the
      Coniston V3 page on 31 August 2026: inside that compartment there is exactly one span, it holds
      the words "Following on" and the Shop wordmark, and it reads rgb(0, 0, 0). Adding a stylesheet
      inside the compartment that paints a span white turned it to rgb(255, 255, 255), and the Shop
      wordmark turned white with it because Shopify draws that wordmark in whatever colour the writing
      around it is set to.

      NOTHING BUT THE COLOUR IS CHANGED. Measured before and after on 31 August 2026: the button stayed
      187 by 36 pixels, its wording stayed "Following on Shop", the small purple pill behind the heart
      stayed rgb(84, 51, 235) and the heart stayed white. The button still does exactly what Shopify
      built it to do when it is pressed.

      THE STYLESHEET IS ADOPTED RATHER THAN PUT IN AS A TAG, AND THAT IS THE DURABLE CHOICE. An adopted
      stylesheet belongs to the compartment itself rather than sitting among its contents, so it
      survives Shopify rebuilding what is inside the button — which happens when a shopper follows or
      unfollows the shop. If a browser is too old to adopt a stylesheet, the block falls back to putting
      an ordinary style tag inside the compartment instead, which does the same job.

      IT IS DELIBERATELY LIMITED TO THE FOOTER. The block only paints the button when it sits inside
      div.footer-follow-on-shop, the theme's own box for it in the navy band. If that same Shopify
      button is ever placed somewhere with a pale background, white writing there would be worse than
      black, so this block simply leaves it alone.

      IT WAITS FOR THE BUTTON INSTEAD OF ASSUMING IT IS THERE. Shopify builds this button after the page
      has arrived, so it does not exist when the page first loads. This block therefore looks for it on
      the same schedule the other blocks in this file use, then keeps looking every half second for
      twenty seconds, and stops the moment it succeeds. It also watches the footer box afterwards, so if
      Shopify ever replaces the whole button the colour is put back.

      IT DOES NOTHING AND SAYS NOTHING IF THE BUTTON IS ABSENT. Sean can switch this button off in the
      theme settings at any time, and some pages may not carry it. Every step below is wrapped up, so a
      missing button, a sealed compartment that cannot be reached, or a future Shopify rebuild that
      changes the shape of the button all end the same way — this block quietly does nothing and no
      error is written anywhere. A footer with black writing is a small blemish; an error thrown on
      every page of the store would be a real fault.

      NO MINTED SECTION ID IS USED, so this survives the next theme duplicate. shop-follow-button is
      Shopify's own tag name and .footer-follow-on-shop is the purchased theme's own stable class name,
      neither of which Shopify rewrites when a theme is duplicated. This obeys section 7 Rule A of
      PR_2_PROJECT_FACTS.md. */
(function () {
  /* The same white the rest of the footer writing already uses. */
  var RULE = 'span { color: rgb(255, 255, 255) !important; }';
  var DONE = 'data-ebd-follow-button-white';
  var tries = 0;
  var timer = null;

  /* The button, but only where Sean asked for it: inside the theme's own footer box. */
  function button() {
    try {
      return document.querySelector('.footer-follow-on-shop shop-follow-button');
    } catch (e) {
      return null;
    }
  }

  /* Puts the stylesheet inside the sealed compartment. Hands back true only if it really got in. */
  function paint(host) {
    var root = host.shadowRoot;
    if (!root) { return false; }
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(RULE);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
      return true;
    } catch (e) {
      /* An older browser cannot adopt a stylesheet, so put in an ordinary style tag instead. */
      try {
        var tag = document.createElement('style');
        tag.textContent = RULE;
        root.appendChild(tag);
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  function apply() {
    try {
      var host = button();
      if (!host) { return false; }
      if (host.getAttribute(DONE) === '1') { return true; }
      if (!paint(host)) { return false; }
      host.setAttribute(DONE, '1');
      return true;
    } catch (e) {
      return false;
    }
  }

  /* If Shopify ever replaces the whole button, put the colour back. Only the small footer box is
     watched, never the whole page. */
  function watch() {
    try {
      var box = document.querySelector('.footer-follow-on-shop');
      if (!box || box.getAttribute('data-ebd-follow-watched') === '1') { return; }
      if (typeof window.MutationObserver !== 'function') { return; }
      new window.MutationObserver(function () { apply(); }).observe(box, { childList: true, subtree: true });
      box.setAttribute('data-ebd-follow-watched', '1');
    } catch (e) {
      /* No watcher is better than a broken page. */
    }
  }

  /* Shopify builds the button late, so keep looking for a while and stop as soon as it is painted.
     Forty tries half a second apart is twenty seconds, after which the page is certainly settled. */
  function keepLooking() {
    if (timer) { return; }
    timer = setInterval(function () {
      tries = tries + 1;
      if (apply() || tries >= 40) {
        clearInterval(timer);
        timer = null;
        watch();
      }
    }, 500);
  }

  function run() { if (!apply()) { keepLooking(); } else { watch(); } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 1200);
  setTimeout(run, 3000);
})();

/* 10) NINE BEHAVIOUR SCRIPTS MOVED HERE FROM sections/header-group.json ON 1 SEPTEMBER 2026.
      PROJECTS-01 E BIKE WEBSITE Planning Page, board task 422_PROJECTS-01, BATCH 209.

      WHAT THIS IS. Document 2.0_DOCS/2.15_WHERE_EVERY_KIND_OF_CODE_GOES.md says behaviour code -
      code that decides what happens when a shopper clicks, scrolls or loads a page - belongs in a
      file ending .js inside assets, never inside a page file or a settings box. These nine scripts
      were all sitting inside the custom-liquid settings box named logo-css inside the theme file
      sections/header-group.json. Every one of them is copied here character for character, in the
      same order they stood in that file, under its own heading naming exactly what it does.

      WHAT WAS LEFT BEHIND, AND WHY. A tenth script in that same settings box - the small coloured
      breakpoint-ruler overlay in the corner of the screen - stayed in sections/header-group.json.
      It reads the theme's own name with the Liquid tags {% assign %} and {{ }}, and a plain .js
      file cannot read a Liquid tag, so it cannot move.

      WHY MOVING THESE NINE IS SAFE. None of the nine contains a Liquid tag. None of them reads
      document.currentScript, so none of them depends on knowing which exact <script> tag is
      running it - the one thing that would have broken by moving. Every one of them finds its own
      elements by searching the page (document.querySelector), so it still runs correctly wherever
      its <script> tag physically sits on the page. The header - and therefore this file's nine
      scripts - loads on every single page of the store, exactly as it did before, so nothing here
      needed a new page check; script 3 already carried its own page check before it moved, and
      still carries it. */

/* FROM sections/header-group.json (logo-css), original script 1 of 10: the desktop logo-size srcset fix (Sean 15 Jul 2026). */
(function(){var B='https://e-bikecentre.co.uk/cdn/shop/files/ebikecentre_logo_v5.png';function fix(){var pic=document.querySelector('.header-heading picture');if(!pic)return;pic.querySelectorAll('source').forEach(function(s){if((s.getAttribute('media')||'').indexOf('min-width')>-1){s.setAttribute('srcset',B+'?width=300 1x, '+B+'?width=600 2x');}});var i=pic.querySelector('img');if(i&&window.innerWidth>=750){i.setAttribute('src',B+'?width=600');}}fix();document.addEventListener('DOMContentLoaded',fix);window.addEventListener('load',fix);})();

/* FROM sections/header-group.json (logo-css), original script 2 of 10: ebc-tablet-sticky - measures header + trust-bar height into CSS vars. */
/* ebc-tablet-sticky: measure header + trust-bar heights into CSS vars so the pinned offsets always fit */(function(){function m(){var h=document.querySelector('#header');var t=document.querySelector('.shopify-section[id$=__trust-bar]');if(h)document.documentElement.style.setProperty('--ebc-hd',Math.round(h.getBoundingClientRect().height)+'px');if(t)document.documentElement.style.setProperty('--ebc-tb',Math.round(t.getBoundingClientRect().height)+'px');}m();window.addEventListener('resize',m);document.addEventListener('DOMContentLoaded',m);window.addEventListener('load',m);})();

/* FROM sections/header-group.json (logo-css), original script 3 of 10: ebc-uniform mover v3 (Sean 19 Jul 2026) - card layout on the 4 bespoke pages. */
/* ebc-uniform mover v3 (Sean 19 Jul): on the 4 bespoke pages from 750px up, move ALL card holders below the columns — a single multi-card holder becomes the 2-up grid, multiple single-card holders are gathered into a 2-column rack */(function(){var PAGES=['/pages/e-bike-insurance','/pages/free-uk-delivery','/pages/klarna-finance','/pages/100-customer-satisfaction','/pages/try-before-you-buy'];var KEYS=['__intro','__try_intro','__how_it_works','__delivery_information'];function apply(){var uniform=PAGES.indexOf(location.pathname)>-1;document.documentElement.classList.toggle('ebc-uniform',uniform);var band=uniform&&window.innerWidth>=750;KEYS.forEach(function(k){document.querySelectorAll('.shopify-section[id$='+k+']').forEach(function(sec){var cols=sec.querySelector('.flexi-features-columns-2');if(!cols)return;var groups=Array.prototype.slice.call(sec.querySelectorAll('.shopify-block.flexi-feature-group'));if(!groups.length)return;if(band){if(groups.length===1){var grp=groups[0];if(!grp.__ebcMoved){grp.__ebcHome={parent:grp.parentElement,next:grp.nextSibling};cols.parentNode.insertBefore(grp,cols.nextSibling);grp.classList.add('ebc-cards-below');grp.__ebcMoved=true;}}else{var wrap=sec.querySelector('.ebc-cards-wrap');if(!wrap){wrap=document.createElement('div');wrap.className='ebc-cards-wrap';cols.parentNode.insertBefore(wrap,cols.nextSibling);}groups.forEach(function(g){if(!g.__ebcMoved){g.__ebcHome={parent:g.parentElement,next:g.nextSibling};wrap.appendChild(g);g.__ebcMoved=true;}});}}else{groups.forEach(function(g){if(g.__ebcMoved&&g.__ebcHome){g.__ebcHome.parent.insertBefore(g,g.__ebcHome.next);g.classList.remove('ebc-cards-below');g.__ebcMoved=false;}});var w2=sec.querySelector('.ebc-cards-wrap');if(w2&&!w2.children.length)w2.remove();}});});}apply();document.addEventListener('DOMContentLoaded',apply);window.addEventListener('load',apply);window.addEventListener('resize',apply);})();

/* FROM sections/header-group.json (logo-css), original script 5 of 10: the mobile no-.co.uk logo swap below 500px (Sean 15 Jul 2026). */
/*1426_EBC v1.1: the existing mobile logo swap supplies 3x off product/collection routes; layout and other runtime features stay unchanged.*/
(function(){var N='https://e-bikecentre.co.uk/cdn/shop/files/ebc_logo_mobile_nocouk.png';var F='https://e-bikecentre.co.uk/cdn/shop/files/ebikecentre_logo_v5.png';function sw(){var img=document.querySelector('.header-heading img');if(!img)return;var small=window.matchMedia('(max-width: 500px)').matches;var mobile3x=small&&!/(^|\/)(products|collections)(\/|$)/.test(window.location.pathname);var mobileSrcset=N+'?width=227 1x, '+N+'?width=454 2x, '+N+'?width=681 3x';if(mobile3x){img.setAttribute('srcset',mobileSrcset);}else if(img.getAttribute('srcset')===mobileSrcset){img.removeAttribute('srcset');}var want=small?N+'?width=454':F+'?width=600';if(img.getAttribute('src')!==want){img.setAttribute('src',want);}var srcs=document.querySelectorAll('.header-heading source');srcs.forEach(function(so){if(small){so.setAttribute('srcset',N+'?width=227 1x, '+N+'?width=454 2x'+(mobile3x?', '+N+'?width=681 3x':''));}else{so.setAttribute('srcset',F+'?width=300 1x, '+F+'?width=600 2x');}});}sw();window.addEventListener('resize',sw);document.addEventListener('DOMContentLoaded',sw);window.addEventListener('load',sw);})();

/* FROM sections/header-group.json (logo-css), original script 6 of 10: wire() - makes the header phone number and email tap-to-call / tap-to-email. */
(function(){function wire(){var c=document.querySelector('.header-brand-info-content');if(!c||c.getAttribute('data-ebc-wired'))return;var ps=c.querySelectorAll('p');if(ps.length<2)return;var ph=ps[0],em=ps[1];var tel=ph.textContent.replace(/[^+0-9]/g,'');ph.innerHTML='<a href="tel:'+tel+'">'+ph.textContent.trim()+'</a>';var ad=em.textContent.trim();em.innerHTML='<a href="mailto:'+ad+'">'+ad+'</a>';c.setAttribute('data-ebc-wired','1');}wire();document.addEventListener('DOMContentLoaded',wire);window.addEventListener('load',wire);})();

/* FROM sections/header-group.json (logo-css), original script 7 of 10: EB_978 (16 Jul 2026) - injects and drives the mobile picture-rail arrows. */
/* Sean 16 Jul (EB_978): inject + drive the rail arrows on mobile (theme only builds/wires them for slider-layout sections at tablet-up). */(function(){var PRE=(function(){var s=document.querySelector('.shopify-section[id$=__slideshow],.shopify-section[id$=__slideshow_roxform]');return s?'#'+s.id.replace(/__slideshow(_roxform)?$/,'__'):'#none__';})();var CFG=[{id:"featured-collection-1",rail:".scroller-inner"},{id:"banner-list-1",rail:".scroller-inner"},{id:"banner_list_categories_v2",rail:".scroller-inner"},{id:"featured-collection-2",rail:".scroller-inner"},{id:"banner-list-2",rail:".scroller-inner"},{id:"banner_list_top_brands_v2",rail:".scroller-inner"},{id:"product-comparison",rail:".product-compare-wrapper"},{id:"blog-posts",rail:".scroller-inner"}];function svg(d){return "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='"+d+"'/></svg>";}function inject(){if(window.innerWidth>=990)return;CFG.forEach(function(c){var sec=document.querySelector(PRE+c.id);if(!sec||sec.getAttribute("data-ebc-nav"))return;var rail=sec.querySelector(c.rail);if(!rail||rail.scrollWidth<=rail.clientWidth+20)return;if(!sec.querySelector(".js-prev")){var holder=sec.querySelector(".section-headings");var wrap=document.createElement("div");wrap.className="section-headings-actions ebc-injected-nav";wrap.innerHTML="<div class='pill-nav pill-nav-slider'><button type='button' class='pill-nav-item pill-nav-item-disabled js-prev' aria-label='Scroll back'>"+svg("M15 6l-6 6l6 6")+"</button><button type='button' class='pill-nav-item js-next' aria-label='Scroll forward'>"+svg("M9 6l6 6l-6 6")+"</button></div>";if(holder){holder.appendChild(wrap);}else{var scroller=rail.closest(".scroller")||rail;scroller.parentElement.insertBefore(wrap,scroller);}}sec.setAttribute("data-ebc-nav","1");});document.querySelectorAll('.shopify-section').forEach(function(sec){if(sec.getAttribute('data-ebc-nav'))return;var rail=sec.querySelector('.product-compare-wrapper')||sec.querySelector('.scroller-inner');if(!rail||rail.scrollWidth<=rail.clientWidth+20)return;if(!sec.querySelector('.js-prev')){var holder=sec.querySelector('.section-headings');var wrap=document.createElement('div');wrap.className='section-headings-actions ebc-injected-nav';wrap.innerHTML="<div class='pill-nav pill-nav-slider'><button type='button' class='pill-nav-item pill-nav-item-disabled js-prev' aria-label='Scroll back'>"+svg("M15 6l-6 6l6 6")+"</button><button type='button' class='pill-nav-item js-next' aria-label='Scroll forward'>"+svg("M9 6l6 6l-6 6")+"</button></div>";if(holder){holder.appendChild(wrap);}else{var scroller=rail.closest('.scroller')||rail;scroller.parentElement.insertBefore(wrap,scroller);}}sec.setAttribute('data-ebc-nav','1');});}inject();function placePC(){if(window.innerWidth>=990)return;var sec=document.querySelector(PRE+"product-comparison");if(!sec)return;var nav=sec.querySelector(".ebc-injected-nav");var h=sec.querySelector(".section-heading");if(!nav||!h)return;var shR=sec.querySelector(".section-headings").getBoundingClientRect();var hR=h.getBoundingClientRect();var cur=parseFloat(nav.style.top)||0;nav.style.top=Math.max(0,Math.round(cur+(hR.top-shR.top)+hR.height/2-(nav.getBoundingClientRect().top-shR.top)-nav.offsetHeight/2))+"px";}placePC();document.addEventListener("DOMContentLoaded",function(){inject();placePC();});window.addEventListener("load",function(){inject();placePC();});window.addEventListener("resize",function(){inject();placePC();});document.addEventListener("click",function(e){if(window.innerWidth>=990)return;var btn=e.target.closest(".js-prev,.js-next");if(!btn)return;var hit=null,sec=null;for(var i=0;i<CFG.length;i++){var s=btn.closest(PRE+CFG[i].id);if(s){hit=CFG[i];sec=s;break;}}if(!hit){sec=btn.closest('.shopify-section');}if(!sec)return;var rail=hit?sec.querySelector(hit.rail):(sec.querySelector('.product-compare-wrapper')||sec.querySelector('.scroller-inner'));if(!rail)return;if((sec.id.endsWith("__featured-collection-1")||sec.id.endsWith("__featured-collection-2"))&&rail.querySelector(".grid-carousel-mobile.flickity-enabled"))return;e.preventDefault();e.stopPropagation();var card=rail.querySelector(".grid-item, td, li, article, .card");var step=card&&card.getBoundingClientRect().width>60?card.getBoundingClientRect().width+16:Math.round(rail.clientWidth*0.8);rail.scrollBy({left:btn.classList.contains("js-prev")?-step:step});setTimeout(function(){var p=sec.querySelector(".js-prev"),n=sec.querySelector(".js-next");if(p)p.classList.toggle("pill-nav-item-disabled",rail.scrollLeft<10);if(n)n.classList.toggle("pill-nav-item-disabled",rail.scrollLeft>rail.scrollWidth-rail.clientWidth-10);},400);},true);})();

/* FROM sections/header-group.json (logo-css), original script 8 of 10: EB_1036 (17 Jul 2026) - injects and drives the contact page 'cities' rail arrows. */
/* Sean 17 Jul (EB_1036): inject + drive the contact-page Useful reading arrows on mobile (same pattern as the homepage EB_978 injector). */(function(){var SEC="[id$='__cities']";function svg(d){return "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='"+d+"'/></svg>";}function inject(){if(window.innerWidth>=990)return;var sec=document.querySelector(SEC);if(!sec||sec.getAttribute("data-ebc-nav"))return;var rail=sec.querySelector(".scroller-inner");if(!rail||rail.scrollWidth<=rail.clientWidth+20)return;if(!sec.querySelector(".js-prev")){var holder=sec.querySelector(".section-headings");var wrap=document.createElement("div");wrap.className="section-headings-actions ebc-injected-nav";wrap.innerHTML="<div class='pill-nav pill-nav-slider'><button type='button' class='pill-nav-item pill-nav-item-disabled js-prev' aria-label='Scroll back'>"+svg("M15 6l-6 6l6 6")+"</button><button type='button' class='pill-nav-item js-next' aria-label='Scroll forward'>"+svg("M9 6l6 6l-6 6")+"</button></div>";if(holder){holder.appendChild(wrap);}else{var scroller=rail.closest(".scroller")||rail;scroller.parentElement.insertBefore(wrap,scroller);}}sec.setAttribute("data-ebc-nav","1");}inject();document.addEventListener("DOMContentLoaded",inject);window.addEventListener("load",inject);document.addEventListener("click",function(e){if(window.innerWidth>=990)return;var btn=e.target.closest(".js-prev,.js-next");if(!btn)return;var sec=btn.closest(SEC);if(!sec)return;var rail=sec.querySelector(".scroller-inner");if(!rail)return;e.preventDefault();e.stopPropagation();var card=rail.querySelector(".grid-item, td, li, article, .card");var step=card&&card.getBoundingClientRect().width>60?card.getBoundingClientRect().width+16:Math.round(rail.clientWidth*0.8);rail.scrollBy({left:btn.classList.contains("js-prev")?-step:step});setTimeout(function(){var p=sec.querySelector(".js-prev"),n=sec.querySelector(".js-next");if(p)p.classList.toggle("pill-nav-item-disabled",rail.scrollLeft<10);if(n)n.classList.toggle("pill-nav-item-disabled",rail.scrollLeft>rail.scrollWidth-rail.clientWidth-10);},400);},true);})();

/* FROM sections/header-group.json (logo-css), original script 9 of 10: the breadcrumb '< Back' control (Sean 17 Jul 2026). */
(function(){function add(){var c=document.querySelector('.breadcrumb .container');if(!c||document.getElementById('ebc-back'))return;var ok=false;try{ok=document.referrer&&new URL(document.referrer).origin===location.origin;}catch(e){}if(!ok)return;var a=document.createElement('a');a.id='ebc-back';a.href='#';a.setAttribute('aria-label','Back to the previous page');a.innerHTML="<span class='ebc-back-arrow'>&#8249;</span>Back";a.addEventListener('click',function(e){e.preventDefault();history.back();});c.appendChild(a);}add();document.addEventListener('DOMContentLoaded',add);})();

/* FROM sections/header-group.json (logo-css), original script 10 of 10: the 'promises' rail arrows (Sean 18 Jul 2026). */
/* Sean 18 Jul: inject + drive the promises rail arrows on mobile (clone of the cities injector). */(function(){var SEC="[id$='__promises']";function svg(d){return "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='"+d+"'/></svg>";}function inject(){if(window.innerWidth>=990)return;var sec=document.querySelector(SEC);if(!sec||sec.getAttribute("data-ebc-nav2"))return;var rail=sec.querySelector(".scroller-inner");if(!rail||rail.scrollWidth<=rail.clientWidth+20)return;if(!sec.querySelector(".js-prev")){var holder=sec.querySelector(".section-headings");var wrap=document.createElement("div");wrap.className="section-headings-actions ebc-injected-nav";wrap.innerHTML="<div class='pill-nav pill-nav-slider'><button type='button' class='pill-nav-item pill-nav-item-disabled js-prev' aria-label='Scroll back'>"+svg("M15 6l-6 6l6 6")+"</button><button type='button' class='pill-nav-item js-next' aria-label='Scroll forward'>"+svg("M9 6l6 6l-6 6")+"</button></div>";if(holder){holder.appendChild(wrap);}else{var scroller=rail.closest(".scroller")||rail;scroller.parentElement.insertBefore(wrap,scroller);}}sec.setAttribute("data-ebc-nav2","1");}inject();document.addEventListener("DOMContentLoaded",inject);window.addEventListener("load",inject);document.addEventListener("click",function(e){if(window.innerWidth>=990)return;var btn=e.target.closest(".js-prev,.js-next");if(!btn)return;var sec=btn.closest(SEC);if(!sec)return;var rail=sec.querySelector(".scroller-inner");if(!rail)return;e.preventDefault();e.stopPropagation();var card=rail.querySelector(".grid-item, td, li, article, .card");var step=card&&card.getBoundingClientRect().width>60?card.getBoundingClientRect().width+16:Math.round(rail.clientWidth*0.8);rail.scrollBy({left:btn.classList.contains("js-prev")?-step:step});setTimeout(function(){var p=sec.querySelector(".js-prev"),n=sec.querySelector(".js-next");if(p)p.classList.toggle("pill-nav-item-disabled",rail.scrollLeft<10);if(n)n.classList.toggle("pill-nav-item-disabled",rail.scrollLeft>rail.scrollWidth-rail.clientWidth-10);},400);},true);})();

/* Sean 24 Sep 2026 (752_PROJECTS-01): pictures blurred on the card-layout pages. The theme tells the browser
   each column picture is half the screen wide, but the card layout shows it full width, so at 1280px the
   browser loaded the 750px copy and stretched it to 1225px. On those pages this tells the browser the
   picture's real width and offers 1920px and 2560px copies too, so every screen gets a sharp one. */
/* 757_PROJECTS-01: the contact page's square-cropped outside view is drawn wider than its box, so it is told its drawn width. */
(function(){function wideCrop(){document.querySelectorAll('.shopify-section[id$=__info] img[src*="try_before_you_buy_v4"]').forEach(function(img){var h=img.getBoundingClientRect().height;if(h>0)img.sizes=Math.ceil(h*3840/2160)+'px';if(img.srcset&&img.srcset.indexOf(' 2560w')<0){var last=img.srcset.split(',').pop().trim().split(' ')[0];if(/width=\d+/.test(last)){img.srcset=img.srcset+', '+last.replace(/width=\d+/,'width=1920')+' 1920w, '+last.replace(/width=\d+/,'width=2560')+' 2560w';}}});}wideCrop();document.addEventListener('DOMContentLoaded',wideCrop);window.addEventListener('load',wideCrop);window.addEventListener('resize',wideCrop);})();
(function(){function sharpen(){if(!document.documentElement.classList.contains('ebc-uniform'))return;document.querySelectorAll('.shopify-section[id$=__intro] img.flexi-media__img,.shopify-section[id$=__try_intro] img.flexi-media__img,.shopify-section[id$=__how_it_works] img.flexi-media__img,.shopify-section[id$=__delivery_information] img.flexi-media__img').forEach(function(img){var box=img.getBoundingClientRect();var w=Math.ceil(box.width);/*1422_EBC v1.2: preserve the two approved square crops while supplying cover-scale detail.*/if(location.pathname==='/pages/try-before-you-buy'&&/(try_before_you_buy_v4|ebc_shop_v7)\.png/.test(img.getAttribute('src')||'')&&window.getComputedStyle(img).objectFit==='cover'){w=Math.ceil(Math.max(box.width,box.height*16/9));}if(w>0)img.sizes=w+'px';if(img.srcset&&img.srcset.indexOf(' 2560w')<0){var last=img.srcset.split(',').pop().trim().split(' ')[0];if(/width=\d+/.test(last)){img.srcset=img.srcset+', '+last.replace(/width=\d+/,'width=1920')+' 1920w, '+last.replace(/width=\d+/,'width=2560')+' 2560w';}}});}sharpen();document.addEventListener('DOMContentLoaded',sharpen);window.addEventListener('load',sharpen);window.addEventListener('resize',sharpen);})();
